var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FeatFlipRoadComponent } from 'app/components/feat-flip-road/feat-flip-road.component';
import { Subject } from 'rxjs';
import { ActivityService } from './activity.service';
import { CommonModalService } from './common-modal.service';
import { EditToolService } from './edit-tool.service';
import { MainDataService } from './main-data.service';
import * as i0 from "@angular/core";
import * as i1 from "./activity.service";
import * as i2 from "./edit-tool.service";
import * as i3 from "./main-data.service";
import * as i4 from "./common-modal.service";
var FlipRoadService = /** @class */ (function () {
    function FlipRoadService(activityService, editToolService, mainDataService, modalService) {
        this.activityService = activityService;
        this.editToolService = editToolService;
        this.mainDataService = mainDataService;
        this.modalService = modalService;
        this.flipRoadSubject = new Subject();
        this.afterFlipRoadSubject = new Subject();
    }
    FlipRoadService.prototype.flipRoadAttrs = function (rec) {
        return __awaiter(this, void 0, void 0, function () {
            var columns, flipRoadCols, currentCardInfo, data, options, rsp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        columns = this.mainDataService.currentColumns;
                        flipRoadCols = this.editToolService.transformLeftRightColumnsToNeutral(columns);
                        // columns.forEach(c => {
                        // 	if (c.prop.endsWith('_l') || c.prop.endsWith('_r')) {
                        // 		const propWithoutDirection = c.prop.substring(0, c.prop.length - 2);
                        // 		const lastSpaceIdx = c.name.lastIndexOf(' ');
                        // 		const neutralName = c.name.substring(0, lastSpaceIdx);
                        // 		let col: FlipRoadColumn = flipRoadCols.find(fc => fc.propWithoutDirection === propWithoutDirection);
                        // 		if (!col) {
                        // 			col = {
                        // 				leftProp: null,
                        // 				leftName: null,
                        // 				rightProp: null,
                        // 				rightName: null,
                        // 				neutralName: neutralName,
                        // 				propWithoutDirection: propWithoutDirection
                        // 			};
                        // 			flipRoadCols.push(col);
                        // 		}
                        // 		if (c.prop.endsWith('_l')) {
                        // 			col.leftProp = c.prop;
                        // 			col.leftName = c.name;
                        // 		} else {
                        // 			col.rightProp = c.prop;
                        // 			col.rightName = c.name;
                        // 		}
                        // 	}
                        // });
                        if (!rec) {
                            currentCardInfo = this.activityService.currentCardBS.getValue();
                            rec = this.mainDataService.getDataAttrs(currentCardInfo.id);
                        }
                        data = {
                            cols: flipRoadCols,
                            record: rec
                        };
                        options = {
                            data: data,
                            width: '450px',
                            height: '600px'
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(FeatFlipRoadComponent, options)];
                    case 1:
                        rsp = _a.sent();
                        return [2 /*return*/, rsp];
                }
            });
        });
    };
    FlipRoadService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FlipRoadService_Factory() { return new FlipRoadService(i0.ɵɵinject(i1.ActivityService), i0.ɵɵinject(i2.EditToolService), i0.ɵɵinject(i3.MainDataService), i0.ɵɵinject(i4.CommonModalService)); }, token: FlipRoadService, providedIn: "root" });
    return FlipRoadService;
}());
export { FlipRoadService };
